import styled from 'styled-components';

import Search from 'assets/svg/Search';
import Cross from 'assets/svg/Cross';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 244px;
  height: 36px;
  border: 1px solid var(--color-grey-e5);
  border-radius: var(--border-radius);
  background-color: var(--color-grey-fb);
  padding: 0 13px;
  position: relative;
  z-index: 100;
  @media (max-width: 1023px) {
    width: calc(100% - 40px);
    height: 50px;
    margin: 0 auto;
    gap: 9px;
    background-color: var(--color-white);
    border-color: var(--color-grey-e5);
    padding: 0 17px;
  }
`;

export const Input = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  outline: none;
  border: none;
  background: none;
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: var(--color-black);
  &::placeholder {
    color: var(--color-grey-73);
    text-align: left;
  }
`;

export const SearchIcon = styled(Search)`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  & > g {
    stroke: var(--color-grey-73);
  }
  @media (max-width: 1023px) {
    width: 38px;
    height: 38px;
    & > g {
      stroke: var(--color-primary);
    }
  }
`;

export const Button = styled.button`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  background: none;
  cursor: pointer;
  @media (max-width: 1023px) {
    width: 38px;
    height: 38px;
  }
`;

export const CloseIcon = styled(Cross)`
  width: 100%;
  height: 100%;
`;
